//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.IntAdapter
import com.apollographql.apollo.api.NullableBooleanAdapter
import com.apollographql.apollo.api.Optional
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.present
import com.wintermar.inspection.graphql.GetSimpleListTemplateQuery
import com.wintermar.inspection.graphql.type.adapter.InspectionTemplateStatus_ResponseAdapter
import kotlin.Boolean
import kotlin.Suppress

public object GetSimpleListTemplateQuery_VariablesAdapter {
  @Suppress(
    "UNUSED_PARAMETER",
    "UNUSED_VARIABLE",
  )
  public fun serializeVariables(
    writer: JsonWriter,
    `value`: GetSimpleListTemplateQuery,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    writer.name("page")
    IntAdapter.toJson(writer, customScalarAdapters, value.page)
    writer.name("pageSize")
    IntAdapter.toJson(writer, customScalarAdapters, value.pageSize)
    if (value.status is Optional.Present) {
      writer.name("status")
      InspectionTemplateStatus_ResponseAdapter.nullable().present().toJson(writer, customScalarAdapters, value.status)
    }
    if (value.archived is Optional.Present) {
      writer.name("archived")
      NullableBooleanAdapter.present().toJson(writer, customScalarAdapters, value.archived)
    }
  }
}
